<div class="chat-container" #chatHistory>
  @for (message of messages(); track message) {
    <nz-row
      class="message-wrapper"
      [ngClass]="message.isBot ? 'bot-wrapper' : 'user-wrapper'"
    >
      @if (message.isBot && isWidgetMode()) {
        <img
          [src]="getImageUrlFromCdnUrl()"
          alt="bot avatar"
          class="bot-avatar"
        />
      }
      <div
        class="message"
        [ngClass]="message.isBot ? 'bot-message' : 'user-message'"
      >
        <div class="chat-message" [innerHTML]="renderChatMessage(message)"></div>
      </div>
    </nz-row>
  }

  @if (isLoading()) {
    <nz-row class="message-wrapper bot-wrapper">
      @if (isWidgetMode()) {
        <img [src]="getImageUrlFromCdnUrl()" alt="bot avatar" class="bot-avatar" />
      }
      <div class="message bot-message">
        <span class="typing"></span>
      </div>
    </nz-row>
  }
</div>

<nz-row nzSpan="24">
  <chatbot-input
    (send)="sendChatMessage($event)"
    (isLoadingChanged)="onLoadingChange($event)"
    class="chat-input"
  ></chatbot-input>
</nz-row>
